import React, { useState } from 'react'
import { Moon, Sun, Monitor } from 'lucide-react'
import { useTheme } from '../contexts/ThemeContext'

const DarkModeToggle = ({ showLabel = false, size = 'default' }) => {
  const { theme, toggleTheme, isDark, followSystemTheme } = useTheme()
  const [showMenu, setShowMenu] = useState(false)

  const sizeClasses = {
    small: 'w-12 h-6',
    default: 'w-14 h-7',
    large: 'w-16 h-8'
  }

  const iconSizes = {
    small: 'w-3 h-3',
    default: 'w-4 h-4',
    large: 'w-5 h-5'
  }

  const handleMainToggle = () => {
    toggleTheme()
    setShowMenu(false)
  }

  return (
    <div className="relative flex items-center gap-3">
      {showLabel && (
        <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
          {theme === 'dark' ? 'Dark Mode' : 'Light Mode'}
        </span>
      )}

      <button
        onClick={handleMainToggle}
        className={`${sizeClasses[size]} relative inline-flex items-center rounded-full transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 dark:focus:ring-offset-gray-800 ${
          isDark ? 'bg-gray-800' : 'bg-gray-300'
        }`}
        aria-label="Toggle dark mode"
        type="button"
      >
        <span
          className={`${
            size === 'small' ? 'w-5 h-5' : size === 'large' ? 'w-7 h-7' : 'w-6 h-6'
          } inline-flex items-center justify-center transform transition-transform duration-300 bg-white rounded-full shadow-md ${
            isDark ? 'translate-x-7' : 'translate-x-1'
          }`}
        >
          {isDark ? (
            <Moon className={`${iconSizes[size]} text-gray-800`} />
          ) : (
            <Sun className={`${iconSizes[size]} text-yellow-500`} />
          )}
        </span>
      </button>

      {/* Small dropdown to quickly follow system preference */}
      <button
        type="button"
        onClick={() => setShowMenu((prev) => !prev)}
        className="hidden sm:inline-flex items-center justify-center w-8 h-8 rounded-full border border-gray-300 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
        aria-label="Theme options"
      >
        <Monitor className="w-4 h-4 text-gray-600 dark:text-gray-300" />
      </button>

      {showMenu && (
        <div className="absolute right-0 top-10 mt-1 w-40 bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 z-20">
          <button
            type="button"
            onClick={() => {
              followSystemTheme()
              setShowMenu(false)
            }}
            className="w-full text-left px-3 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-t-lg"
          >
            Follow System
          </button>
          <button
            type="button"
            onClick={() => {
              handleMainToggle()
            }}
            className="w-full text-left px-3 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-b-lg"
          >
            Toggle Light / Dark
          </button>
        </div>
      )}
    </div>
  )
}

export default DarkModeToggle